import { Injectable } from '@angular/core';
import {Constants} from '../config/constants';

@Injectable()
export class AppGlobal {
  public profileImageUrlLocalKey: string = "profileImageUrlLocalKey";
  public prefixUrlRoleLocalKey: string = "prefixUrlRole";
  public roleNameLocalKey: string = "roleName";
  public roleLocalKey: string = "role";
  public emailCurrentUserLoginLocalKey: string = "emailCurrentUserLogin";
  public schoolCurrentUserLoginLocalKey: string = "schoolCurrentUserLogin";

  public refer_profileImageUrlLocalKey: string = "refer_profileImageUrlLocalKey";
  public refer_prefixUrlRoleLocalKey: string = "refer_prefixUrlRole";
  public refer_roleNameLocalKey: string = "refer_roleName";
  public refer_roleLocalKey: string = "refer_role";
  public refer_emailCurrentUserLoginLocalKey: string = "refer_emailCurrentUserLogin";
  public refer_schoolCurrentUserLoginLocalKey: string = "refer_schoolCurrentUserLogin";

  public profileImageUrl: string;
  public prefixUrlRole: string;
  public roleName: string;
  public emailCurrentUserLogin: string;
  public schoolCurrentUserLogin: string;
  public role: number = -1;

  public refer_profileImageUrl: string;
  public refer_prefixUrlRole: string;
  public refer_roleName: string;
  public refer_emailCurrentUserLogin: string;
  public refer_schoolCurrentUserLogin: string;
  public refer_role: number = -1;

  public roleSuperAdmin: number = Constants.ROLE_SUPER_ADMIN;
  public roleSystemAdmin: number = Constants.ROLE_SYSTEM_ADMIN;
  public roleSchoolAdmin: number = Constants.ROLE_SCHOOL_ADMIN;
  public roleMentor: number = Constants.ROLE_MENTOR;
}



// WEBPACK FOOTER //
// ./src/app/common/app.global.ts